/**
 * @file priority-cell-header.icon.tsx
 * @description Компонент для отображения иконки приоритета для заголовка.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const PriorityCellHeader = ({ className, size = '1.6937vmin', color = 'black', onClick }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick}>
            <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5H13V6H9V5Z" fill={color} />
                <path d="M9 8H13V9H9V8Z" fill={color} />
                <path d="M9 11H13V12H9V11Z" fill={color} />
                <path fillRule="evenodd" clipRule="evenodd" d="M6 5V12H5V5H6Z" fill={color} />
                <path
                    d="M3.00031 5.50177L5.49937 3.00209L8.00333 5.50192L5.50006 5.50177L3.00031 5.50177Z"
                    fill={color}
                />
            </svg>
        </div>
    );
};
